import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/user/getTodosLosPermisos.php';

export default function getTodosLosPermisos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}